/**
 * Quando quem não está logado vê o site do RPG Desk (docs/spec/landing.md): sem conta salva, sem
 * convite, fora do app de Windows e do app instalado. Os outros vão direto ao formulário de entrar.
 */
export type EntryContext = {
  /** a conta salva neste navegador (com ela, o `/api/me` está respondendo) */
  token: string | null;
  /** o `location.search` da página: `?room=` é um convite */
  search: string;
  /** o app de Windows */
  desktop: boolean;
  /** o app instalado (a tela inicial do celular ou do computador) */
  standalone: boolean;
};

export function showSiteFirst({ token, search, desktop, standalone }: EntryContext): boolean {
  if (token || desktop || standalone) return false;
  return !new URLSearchParams(search).has('room');
}

/** O contexto da página de verdade. */
export function browserEntry(token: string | null): EntryContext {
  return {
    token,
    search: window.location.search,
    desktop: !!(window as { rpgDeskDesktop?: unknown }).rpgDeskDesktop,
    standalone: typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches,
  };
}
